export const getCookie = (name: string) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const eraseCookie = (name: string) => {
  document.cookie = `${name}=;Path=/;Expires=${new Date(0).toUTCString()}`;
};

export const setCookie = (name: string, value: string, options = {} as any) => {
  let local = options;
  local = {
    path: '/',
    ...local,
  };
  if (local.expires instanceof Date) {
    local.expires = local.expires.toUTCString();
  }
  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  Object.keys(local).forEach((optionKey) => {
    updatedCookie += `; ${optionKey}`;
    const optionValue = local[optionKey];
    if (optionValue !== true) {
      updatedCookie += `=${optionValue}`;
    }
  });

  document.cookie = updatedCookie;
};
